/* global $ */

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

// Make bootstrap globally available
window.bootstrap = bootstrap

// Import datepicker
import Datepicker from '../../node_modules/vanillajs-datepicker/js/Datepicker.js'

// Import CKEditor
import ClassicEditor from './ckeditor.ts'

// Import Tagify
import { initTagify } from './tags-handler.js'

// Import our custom CSS
import '../scss/main.scss'

// CKEditor initialization
if ($('.ckeditor').length) {
  ClassicEditor.create(document.querySelector('.ckeditor'), {
    heading: {
      options: [
        { model: 'paragraph', view: 'p', title: 'Normaal' },
        { model: 'heading2', view: 'h2', title: 'Kop 2' },
        { model: 'heading3', view: 'h3', title: 'Kop 3' },
      ],
    },
  }).catch((error) => {
    throw error
  })
}

document.addEventListener('DOMContentLoaded', function () {
  initTagify()
})

$('[data-confirm-text]').each(function confirmLinkAction() {
  const $this = $(this)
  const eventType = $this.is('form') ? 'submit' : 'click'
  $this.on(eventType, () => {
    if (!window.confirm($this.data('confirm-text'))) {
      return false
    }
    return true
  })
})

$('[data-search-field]').each(function searchForTag() {
  const $this = $(this)
  const searchField = $(`#${$this.data('search-field')}`)
  $this.on('click', () => {
    if (searchField.val().indexOf($this.text().trim()) > -1) {
      return
    }
    searchField.val(`${searchField.val().trim()} ${$this.text().trim()}`)
    searchField.parents('form')[0].submit()
  })
})

$(() => {
  $('.js-datepicker').each((idx, elem) => {
    new Datepicker(elem, {
      buttonClass: 'btn',
      format: 'yyyy-mm-dd',
      autohide: true,
    })
  })
})

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
Array.from(tooltipTriggerList).forEach((tooltipTriggerEl) => {
  new bootstrap.Tooltip(tooltipTriggerEl)
})
